.loader {
  --dot: var(--cxy-color-text-default-body);
  --dot-70: color-mix(in srgb, var(--dot) 70%, transparent);
  --dot-50: color-mix(in srgb, var(--dot) 50%, transparent);
  --dot-30: color-mix(in srgb, var(--dot) 30%, transparent);
  display: block;
  font-size: 5px;
  width: 1.2em;
  height: 1.2em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  animation: mulShdSpin 1.1s infinite ease;
  transform: translateZ(0);
}

@keyframes mulShdSpin {
  0%,
  100% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot),
      1.8em -1.8em 0 0em var(--dot-30),
      2.5em 0em 0 0em var(--dot-30),
      1.75em 1.75em 0 0em var(--dot-30),
      0em 2.5em 0 0em var(--dot-30),
      -1.8em 1.8em 0 0em var(--dot-30),
      -2.6em 0em 0 0em var(--dot-50),
      -1.8em -1.8em 0 0em var(--dot-70);
  }
  12.5% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-70),
      1.8em -1.8em 0 0em var(--dot),
      2.5em 0em 0 0em var(--dot-30),
      1.75em 1.75em 0 0em var(--dot-30),
      0em 2.5em 0 0em var(--dot-30),
      -1.8em 1.8em 0 0em var(--dot-30),
      -2.6em 0em 0 0em var(--dot-30),
      -1.8em -1.8em 0 0em var(--dot-50);
  }
  25% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-50),
      1.8em -1.8em 0 0em var(--dot-70),
      2.5em 0em 0 0em var(--dot),
      1.75em 1.75em 0 0em var(--dot-30),
      0em 2.5em 0 0em var(--dot-30),
      -1.8em 1.8em 0 0em var(--dot-30),
      -2.6em 0em 0 0em var(--dot-30),
      -1.8em -1.8em 0 0em var(--dot-30);
  }
  37.5% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-30),
      1.8em -1.8em 0 0em var(--dot-50),
      2.5em 0em 0 0em var(--dot-70),
      1.75em 1.75em 0 0em var(--dot),
      0em 2.5em 0 0em var(--dot-30),
      -1.8em 1.8em 0 0em var(--dot-30),
      -2.6em 0em 0 0em var(--dot-30),
      -1.8em -1.8em 0 0em var(--dot-30);
  }
  50% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-30),
      1.8em -1.8em 0 0em var(--dot-30),
      2.5em 0em 0 0em var(--dot-50),
      1.75em 1.75em 0 0em var(--dot-70),
      0em 2.5em 0 0em var(--dot),
      -1.8em 1.8em 0 0em var(--dot-30),
      -2.6em 0em 0 0em var(--dot-30),
      -1.8em -1.8em 0 0em var(--dot-30);
  }
  62.5% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-30),
      1.8em -1.8em 0 0em var(--dot-30),
      2.5em 0em 0 0em var(--dot-30),
      1.75em 1.75em 0 0em var(--dot-50),
      0em 2.5em 0 0em var(--dot-70),
      -1.8em 1.8em 0 0em var(--dot),
      -2.6em 0em 0 0em var(--dot-30),
      -1.8em -1.8em 0 0em var(--dot-30);
  }
  75% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-30),
      1.8em -1.8em 0 0em var(--dot-30),
      2.5em 0em 0 0em var(--dot-30),
      1.75em 1.75em 0 0em var(--dot-30),
      0em 2.5em 0 0em var(--dot-50),
      -1.8em 1.8em 0 0em var(--dot-70),
      -2.6em 0em 0 0em var(--dot),
      -1.8em -1.8em 0 0em var(--dot-30);
  }
  87.5% {
    box-shadow:
      0em -2.6em 0em 0em var(--dot-30),
      1.8em -1.8em 0 0em var(--dot-30),
      2.5em 0em 0 0em var(--dot-30),
      1.75em 1.75em 0 0em var(--dot-30),
      0em 2.5em 0 0em var(--dot-30),
      -1.8em 1.8em 0 0em var(--dot-50),
      -2.6em 0em 0 0em var(--dot-70),
      -1.8em -1.8em 0 0em var(--dot);
  }
}
